export const MAX_SIZE_MB = 10;

export const validCoordinateSystemNames = ["urn:ogc:def:crs:OGC:1.3:CRS84"];
